import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IAuthStore } from "@/templates/authManagement/authStore/types";
import { IAuthStepEnum } from "@/templates/authManagement/authStore/types";

const initialState = {
  step: IAuthStepEnum.LOGIN,
  forgetPasswordMeteData: { userName: "", otp: "", reqId: "" },
};

export const useAuthStore = create<IAuthStore>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        ...initialState,

        setStep: (state) => {
          set({ step: state });
        },
        setForgetPasswordMeteData: (data) => {
          set({ forgetPasswordMeteData: data });
        },
        resetState: () => {
          set({ ...initialState });
        },
      }),
      {
        enabled: !import.meta.env.PROD,
        name: "authStore",
      },
    ),
  ),
);
